export default __webpack_public_path__ + "static/media/CL01.cf44b70e.mp3";